import React from 'react';
import { ChartConfig } from '../../types';
import ChartVisualization from './ChartVisualization';

interface VisualizationDisplayProps {
  visualization: ChartConfig;
}

const VisualizationDisplay: React.FC<VisualizationDisplayProps> = ({ 
  visualization 
}) => {
  // Helper to check if data is valid (handles both array and JSON string)
  const checkValidData = (data: any) => {
    if (!data) return false;
    if (Array.isArray(data)) return data.length > 0;
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return Array.isArray(parsed) && parsed.length > 0;
      } catch {
        return false;
      }
    }
    return false;
  };

  // Check if we should render anything at all
  if (!visualization || visualization.type === 'none') {
    return null;
  }

  // Check if there's valid data to display
  const hasValidData = checkValidData(visualization.graphJSON?.data) || checkValidData(visualization.data);
  if (!hasValidData) {
    return null;
  }

  return (
    <div className="rounded-xl overflow-hidden mb-4 border border-neutral-dark dark:border-dark-border">
      <div className="flex justify-between items-center bg-neutral-dark dark:bg-dark-secondary px-4 py-2">
        <h3 className="text-sm font-medium text-black dark:text-dark-textPrimary">Data Visualization</h3>
      </div>
      <div className="bg-white dark:bg-dark-secondary">
        <ChartVisualization 
          config={visualization} 
          // height={chartHeight}
          // height={400}
          // height={500}
        />
      </div>
    </div>
  );
};

export default VisualizationDisplay;
